<template>
  <div id="paymentCaution">
    <div class="input_list">
      <div class="dd_text">
        <h2>クレジットカードでお支払い：</h2>
        <ul class="text_li">
          <li>以下のマークがついているクレジットカードでお支払い頂けます。</li>
          <li>ご注文の確認が出来次第、製造を開始いたします。</li>
          <li>
            <img :src="imgCreditMufg" alt="mufg">
            <img :src="imgCreditDc" alt="dc">
            <img :src="imgCreditMaster" alt="master">
            <img :src="imgCreditNicos" alt="nicos">
            <img :src="imgCreditUfj" alt="ufj">
            <img :src="imgCreditVisa" alt="visa">
          </li>
        </ul>
      </div>
      <div class="dd_text">
        <h2>金融機関でのお支払い：</h2>
        <ul class="text_li">
          <li>商品は入金確認後に製造開始いたします。</li>
          <li>お振込み期限を過ぎますと希望納期に間に合わない場合はございます。</li>
          <li>次ページの決済ページにより振込期限をご確認の上、期間内にお支払いいただけますようお願い致します。</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import * as App from '../../../utils/App'

export default {
  name: 'PaymentCaution',
  components: {
  },
  props: {
    index: Number,
    itemData: Object
  },
  data () {
    return {
      imgCreditMufg: this.getImage('order/credit/ECCRD_MUFG.gif'),
      imgCreditDc: this.getImage('order/credit/ECCRD_DC.gif'),
      imgCreditMaster: this.getImage('order/credit/ECCRD_Master.gif'),
      imgCreditNicos: this.getImage('order/credit/ECCRD_NICOS.gif'),
      imgCreditUfj: this.getImage('order/credit/ECCRD_UFJ.gif'),
      imgCreditVisa: this.getImage('order/credit/ECCRD_VISA.gif')
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/order/PaymentCaution.vue